import { api } from "utils";
import {
  fetchOrderPaymentInfo,
  fetchOrderPaymentInfoList,
  fetchReceivableInfo,
  fetchReceivableInfoList,
  fetchBranchReceivableInfo,
  fetchBranchReceivableInfoList,
  fetchVoucherInfo,
  fetchVoucherInfoList,
} from "./salesSlice";

/**
 * 공통 내부 함수
 */

const getSearchEndDate = (searchPeriodType, searchDate) => {
  const startDate = new Date(searchDate);
  switch (searchPeriodType) {
    case "daily":
      return searchDate;
    case "weekly":
      return startDate.getEndDateInWeek().getCalendar();
    case "monthly":
      return startDate.getEndDateInMonth().getCalendar();
  }
};

/**
 * 이용권 종류별 매출 회원 목록 (상세)
 */

export const updateVoucherInfoList = (isUpdate) => (dispatch, getState) => {
  const voucherInfo = getState().sales.voucherInfo;
  const partnerInfo = getState().partner;

  const searchPartner = voucherInfo.searchPartner;
  const searchBranch = voucherInfo.searchBranch;
  const searchDate = voucherInfo.searchDate;
  const searchPeriodType = voucherInfo.searchPeriodType;
  const searchFilter = voucherInfo.searchFilter || "ALL";

  if (!searchPartner || !searchDate) return;

  const startDate = voucherInfo.searchDate;
  const endDate = getSearchEndDate(
    voucherInfo.searchPeriodType,
    voucherInfo.searchDate
  );

  if (isUpdate) {
    dispatch(
      fetchVoucherInfo({
        pageState: undefined,
      })
    );

    api
      .post("/sales/services", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        startDate: startDate,
        endDate: endDate,
        filter: searchFilter,
        criteria: {
          page: voucherInfo.page,
          pageSize: voucherInfo.pageSize,
        },
        branchUseYn: "Y",
        lastSeqOrderPayment: voucherInfo.dataList.lastSeqOrderPayment,
        lastSeqRefundInfo: voucherInfo.dataList.lastSeqRefundInfo,
      })
      .then(({ data }) => {
        const paymentList = (data.page || {}).results || [];
        dispatch(
          fetchVoucherInfoList({
            paymentList: paymentList || [],
            lastSeqOrderPayment: data.lastSeqOrderPayment || 0,
            lastSeqRefundInfo: data.lastSeqRefundInfo || 0,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          fetchVoucherInfo({
            pageState: false,
          })
        );
      });
  } else {
    dispatch(
      fetchVoucherInfo({
        dataList: {
          searchInfo: {
            searchPartner: voucherInfo.searchPartner,
            searchBranch: voucherInfo.searchBranch,
            searchDate: voucherInfo.searchDate,
            searchPeriodType: voucherInfo.searchPeriodType,
            searchFilter: voucherInfo.searchFilter,
          },
          paymentList: [],
          lastSeqOrderPayment: 0,
          lastSeqRefundInfo: 0,
        },
        page: 1,
        pageState: true,
      })
    );
  }
};

/**
 * 주문 결제 내역 목록 (상세)
 */

export const updateOrderPaymentList = (isUpdate) => (dispatch, getState) => {
  const detailSummaryInfo = getState().sales.detailSummaryInfo;
  const paymentInfo = getState().sales.orderPaymentInfo;
  const partnerInfo = getState().partner;

  const searchPartner = detailSummaryInfo.searchPartner;
  const searchBranch = detailSummaryInfo.searchBranch;
  const searchDate = detailSummaryInfo.searchDate;
  const searchPeriodType = detailSummaryInfo.searchPeriodType;
  const searchFilter = detailSummaryInfo.searchFilter;

  if (!searchPartner || !searchDate) return;

  const startDate = searchDate;
  const endDate = getSearchEndDate(searchPeriodType, searchDate);

  if (isUpdate) {
    const timestamp = Date.now();

    dispatch(
      fetchOrderPaymentInfo({
        pageState: undefined,
        timestamp: timestamp,
      })
    );

    api
      .post("/sales/period/total-sales-by-day", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        startDate: searchDate,
        endDate: endDate,
        filter: searchFilter || "ALL",
        criteria: {
          page: paymentInfo.page,
          pageSize: paymentInfo.pageSize,
        },
        branchUseYn: "Y",
        lastSeqOrderPayment: paymentInfo.lastSeqOrderPayment,
        lastSeqRefundInfo: paymentInfo.lastSeqRefundInfo,
      })
      .then(({ data }) => {
        const orderPaymentInfo = getState().sales.orderPaymentInfo;
        if (timestamp == orderPaymentInfo.timestamp) {
          const paymentList = (data.page || {}).results || [];
          dispatch(
            fetchOrderPaymentInfoList({
              paymentList: paymentList || [],
              lastSeqOrderPayment: data.lastSeqOrderPayment || 0,
              lastSeqRefundInfo: data.lastSeqRefundInfo || 0,
            })
          );
        }
      })
      .catch((error) => {
        const orderPaymentInfo = getState().sales.orderPaymentInfo;
        if (timestamp == orderPaymentInfo.timestamp) {
          console.log(error);
          dispatch(
            fetchOrderPaymentInfo({
              pageState: false,
            })
          );
        }
      });
  } else {
    dispatch(
      fetchOrderPaymentInfo({
        data: {
          searchInfo: {
            searchPartner: searchPartner,
            searchBranch: searchBranch,
            searchDate: searchDate,
            searchPeriodType: searchPeriodType,
            searchFilter: searchFilter,
          },
          paymentList: [],
        },
        page: 1,
        pageState: true,
        lastSeqOrderPayment: 0,
        lastSeqRefundInfo: 0,
      })
    );
  }
};

/**
 * 현재 누적 미수금 관련
 */

export const updateReceivableInfo =
  (searchInfo, action) => (dispatch, getState) => {
    const partnerInfo = getState().partner;
    const searchPartner = searchInfo.searchPartner || 0;
    const searchBranch = searchInfo.searchBranch || 0;
    const branchUseYn =
      searchInfo.branchUseYn || partnerInfo.branchUseYn || "N";
    const searchDate = searchInfo.searchDate;

    if (!searchDate || !searchPartner) return;

    const fetchUrl = "/sales/accumulate-receivables";
    const fetchData = {
      seqPartner: searchPartner,
      seqPartnerBranch: searchBranch,
      branchUseYn: branchUseYn,
    };

    dispatch(
      action({
        searchPartner: searchPartner,
        searchBranch: searchBranch,
        searchDate: searchDate,
        isLoading: true,
        isError: false,
      })
    );
    api
      .post(fetchUrl, fetchData)
      .then(({ data }) => {
        const receivableAmount = data.accumulateReceivables || 0;
        dispatch(
          action({
            data: {
              searchInfo: {
                searchPartner: searchPartner,
                searchBranch: searchBranch,
                searchDate: searchDate,
              },
              receivableAmount: receivableAmount,
            },
            isLoading: false,
            isError: false,
          })
        );
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          action({
            isLoading: false,
            isError: true,
          })
        );
      });
  };

export const updateReceivableInfoList = (isUpdate) => (dispatch, getState) => {
  const partnerInfo = getState().partner;
  const receivableInfo = getState().sales.receivableInfo;

  const searchPartner = receivableInfo.searchPartner || 0;
  const searchBranch = receivableInfo.searchBranch || 0;
  const searchDate = receivableInfo.searchDate;

  if (!searchDate || !searchPartner) return;

  if (isUpdate) {
    dispatch(
      fetchReceivableInfo({
        pageState: undefined,
      })
    );
    api
      .post("/sales/normal-center/receivables", {
        seqPartner: searchPartner,
        seqPartnerBranch: searchBranch,
        criteria: {
          page: receivableInfo.page,
          pageSize: receivableInfo.pageSize,
        },
      })
      .then(({ data }) => {
        const receivableList =
          (data.normalCenterReceivableItems || {}).results || [];
        dispatch(fetchReceivableInfoList(receivableList));
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          fetchReceivableInfo({
            pageState: false,
          })
        );
      });
  } else {
    dispatch(
      fetchReceivableInfo({
        dataList: [],
        page: 1,
        pageState: true,
      })
    );
  }
};

export const updateBranchReceivableInfoList =
  (isUpdate) => (dispatch, getState) => {
    const partnerInfo = getState().partner;
    const branchReceivableInfo = getState().sales.branchReceivableInfo;
    const searchPartner = branchReceivableInfo.searchPartner || 0;
    const searchDate = branchReceivableInfo.searchDate;
    if (!searchDate || !searchPartner) return;

    if (isUpdate) {
      dispatch(
        fetchBranchReceivableInfo({
          pageState: undefined,
        })
      );
      api
        .post("/sales/integrated-center/receivables", {
          seqPartner: searchPartner,
          criteria: {
            page: branchReceivableInfo.page,
            pageSize: branchReceivableInfo.pageSize,
          },
        })
        .then(({ data }) => {
          const branchReceivableList =
            (data.integratedCenterReceivableItems || {}).results || [];
          dispatch(fetchBranchReceivableInfoList(branchReceivableList));
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            fetchBranchReceivableInfo({
              pageState: false,
            })
          );
        });
    } else {
      dispatch(
        fetchBranchReceivableInfo({
          dataList: [],
          page: 1,
          pageState: true,
        })
      );
    }
  };
